/**
 * @author      carlos.soto@zumper.com (Carlos J. Soto)
 * @copyright   Copyright (c) 2023, Zumper
 * @description stripUrlParam
 */

import { type LocationDescriptorObject, createPath } from 'history'

export const stripUrlParam = (location: string | LocationDescriptorObject, key: string) => {
  const path = typeof location === 'string' ? location : createPath(location)
  const re = new RegExp(`([?&])(?:${key})[&]`, 'i')
  const re2 = new RegExp(`(?:[?&])(?:${key})$`, 'i')
  return path.replace(re, '$1').replace(re2, '')
}
